<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-row mu-w-100 mu-gap-04">
            <h1 class="mu-mb-00">Group details</h1>
            <details class="mcc-popover mcc-popover--bottom-end">
                <summary class="mcc-button mcc-button--icon-only ">
                    <mcc-icon class="mcc-icon--secondary" width="32" height="32" name="help" aria-hidden="true"></mcc-icon>
                </summary>
                <div class="mcc-popover__content">
                    <p class="mu-mb-00">
                        {{ helpText.title }}
                        <a :href="helpText.url" target="_blank">Read more...</a>
                    </p>
                </div>
            </details>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Users & groups</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">Groups</a>
                    </li>
                    <li aria-current="page">{{groupName }}</li>
                </ol>
            </nav>
        </div>
        
        <div style="position:relative">
            <div v-if="!updateCall" class="spinner-overlay">
                <div class="spinner-background"></div>
                <div class="spinner-flex">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div class="mcc-card">
                <form novalidate ref="groupForm" id="formId" @submit.prevent="saveGroup()">
                <div class="mcc-row ">
                    <div class="mcc-row" v-if="fetchCall">
                        <div class="mcc-col">
                            <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact mu-ml-06 mu-pl-07 mu-mt-06"  v-if="dto.group.deleted!= null" id="disableWarning"  color="warning">
                                <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                <p>
                                    <strong>Warning!</strong>
                                    <br />This group has been disabled and cannot be changed.
                                    <br />
                                    Reason: {{dto.group.deletedReason}}
                                </p>
                            </mcc-alert>
                        </div>
                    </div>
                    <div class="mcc-col ">
                        <div class="mcc-card mu-m-06">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Details</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <div class="mfc-input-wrapper  mu-d-block mfc-form-input-container  mfc-form-input-wrapper--width">
                                            <label for="name" class="mfc-label mfc-label--required">Name</label>
                                            <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" :readonly="isReadOnly" ref="name" :value="dto.group.name" :pattern="nameRegex" @change="updateName($event)">
                                        </div>
                                        <div class="mfc-textarea-wrapper mfc-form-input-wrapper--width  mfc-form-input-container mu-mt-03">
                                            <label for="description">Description</label>
                                            <textarea id="description" name="description" maxlength="100" :readonly="isReadOnly" ref="description" placeholder="Description" :value="dto.group.description" :pattern="descRegex" @input="dto.group.description = $event.target.value" character-count=""></textarea>
                                            <div class="mfc-invalid-feedback"></div>
                                            <span class="mfc-help-text" v-if="dto.group.description">You have {{100 - dto.group.description.length}} characters remaining</span>
                                            <span class="mfc-help-text" v-else>You have 100 characters remaining</span>
                                        </div>
                                        <label class="mfc-label" v-if="hierarchyInfo.length>0">Hierarchy charts</label>
                                        <div>
                                            <span v-for="(app,key) in hierarchyInfo" :key="key">
                                                <router-link :to="CONTEXT_PATH + '/usersgroups/hierarchies/'+app.id">
                                                    {{app.name}}
                                                </router-link>
                                                <span v-if="key!=hierarchyInfo.length-1">,</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mcc-row">
                    <div class="mcc-col ">
                        <div class="mcc-card mu-ml-06 mu-mr-06 usercardHeight">
                            <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                                <div>
                                    <h2 class="mcc-card__title">Users</h2>
                                </div>
                            </div>
                            <div class="mcc-card__body" id="groupEditCardBody">
                                <div class="mcc-row">
                                    <div class="mcc-col ">
                                        <Picklist ref="userList" label=" " id="userList" name="userList" :disabled="isReadOnly && !systemAdminGroup" ></Picklist>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mu-m-06">
                    <div class="mu-d-flex mu-justify-content-end">
                        <div role="group" class="mcc-button-group mcc-button-group--spaced">
                        <button class="mcc-button mcc-button--outline" v-if="newGroup" @click="handleCancelBtn()" id="cancelBtn" title="Cancel" type="button">
                            <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                        </button>
                        <button class="mcc-button mcc-button--soft-warning" title="Disable" :disabled="isReadOnly" v-if="!newGroup && dto.group.deleted==null" id="disableBtn" @click="openDisableDialog() " type="button">
                            <mcc-icon name="unavailable" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Disable</span>
                        </button>
                        <button class="mcc-button mcc-button--primary" v-if="dto.group.deleted!=null" id="enableBtn" @click="enableGroup()" title="Enable" type="button">
                            <mcc-icon name="undo" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Enable</span>
                        </button>
                        <button class="mcc-button mcc-button--success " :disabled="isReadOnly && !systemAdminGroup"  v-if="newGroup || dto.group.deleted==null" id="saveBtn" title="Save" type="submit">
                            <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                        </button>
                    </div>
                    </div>
                </div>
            </form>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="disableModal" id="disableModal" v-if="dataLoaded">
            <form novalidate id="disableGroup">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Disable</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div v-if="updateDialog">
                                    <div class="mfc-textarea-wrapper mfc-form-input-container">
                                        <label for="disableReason" class="mfc-label--required">Disable reason</label>
                                        <textarea id="disableReason" name="disableReason" ref="disableReason" required="" maxlength="100" rows="6" :pattern="descRegex" :value="disableReason" @change="updateReason($event)" @input="disableReason = $event.target.value" character-count=""></textarea>
                                        <div class="mfc-invalid-feedback"></div>
                                        <span class="mfc-help-text" v-if="disableReason">
                                            You have {{100 - disableReason.length}} characters remaining
                                            <br>
                                        </span>
                                        <span class="mfc-help-text" v-else>
                                            You have 100 characters remaining
                                            <br>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeDialog()">Close</button>
                            <button type="button" class="mcc-button mcc-button--warning" @click="disableGroup($event)">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import Picklist from "../../customComponents/Picklist.vue";
import GroupAPI from "../../../services/GroupAPI";
import {
    EventBus
} from "../../../services/event-bus";
import {
    handleFormValidation,
    validationMessages,displayErrorMessage, 
    checkFormAndTextareaValidations
} from '@/formvalid.js';
import constantMessages from "../../../messages";
import Utils from "@/script_utils";

export default {
    name: "GroupEdit",
    components: {
        Picklist,
    },
    data() {
        return {
            dto: {
                group: {
                    name: '',
                    description: '',
                    deleted: null,
                    disableReason: ''
                }
            },
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            helpText: constantMessages.BREADCRUMB_HELP["group.edit"],
            showHelpText: false,
            groupId: this.$route.params.groupId,
            dataLoaded: false,
            groupName: "",
            isReadOnly: false,
            fetchCall: false,
            newGroup: false,
            showData: false,
            disableReason: '',
            updateDialog: false,
            restrictDisable: false,
            disableRestrictMsg: '',
            hierarchyInfo: [],
            systemAdminGroup: false,
            updateCall: true,
            hierarchyId: "",
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        self.fetchCall = false;
        let url = "/usersgroups/groupsAPI/" + self.groupId;
        if (self.groupId == 'new') {
            self.helpText = constantMessages.BREADCRUMB_HELP["group.create"];
            self.newGroup = true;
            self.groupName = "Create new";
            self.showData = true;
            url = "/usersgroups/groupsAPI/getGroupUserInfo"
            if (self.$route.query.hierarchyId) {
                self.hierarchyId = self.$route.query.hierarchyId;
                url += "?hierarchyId=" + self.$route.query.hierarchyId;
                if (self.$route.query.parentId) {
                    url += "&parentId=" + self.$route.query.parentId;
                }
                if (this.$route.query.childId) {
                    url += "&childId=" + self.$route.query.childId;
                }
            }
        }
        GroupAPI.getGroupInfo(url)
            .then(result => {
                self.dataLoaded = true;
                self.dto = result;
                if (!self.newGroup) {
                    this.groupName = self.dto.group.name;
                    self.restrictDisable = self.dto.ERROR != "";
                    self.disableRestrictMsg = self.dto.ERROR;
                    self.isReadOnly = self.dto.isDisabled || self.dto.group.deleted != null;
                    self.hierarchyInfo = self.dto.group.groupInCharts;
                    self.systemAdminGroup = self.groupName == 'SYSTEMADMINISTRATORS';
                }
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.group.details"] + " - " + self.groupName;
                EventBus.$emit("update-pageTitle", pageTitle);

            }).finally(() => {
                self.fetchCall = true;
                self.loadUers();
            });

    },
    methods: {
        updateReason(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason is required")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason must be valid")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else {
                self.$refs.disableReason.classList.remove("ms-is-invalid")
                self.invalidDisableReason = false;
            }
            self.disableReason = $event.target.value;
        },
        handleValidation() {
            let invalid = false;
            let self = this;
            if (!this.dto.group?.name) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
                invalid = true;
            }

            return invalid;
        },
        async loadUers(users) {
            let self = this;
            self.updateCall = false;

            await this.$nextTick();
            setTimeout(function () {
                self.$refs.userList.setData(self.dto.availableUsers,self.dto.assignedUsers);
                self.$refs.userList.value = self.dto.assignedUsers;
                self.updateCall = true;

            }, 2000);
        },
        openDisableDialog() {
            let self = this;
            self.updateDialog = true;
            if (self.restrictDisable) {
                EventBus.$emit("error-notification", {
                    msg: constantMessages.MESSAGES[self.disableRestrictMsg]
                });

                return;
            }
            this.disableReason = "";
            self.$refs.disableModal.show();
        },
        closeDialog() {
            let self = this;
            let form = $('#disableGroup')
            form[0].classList.remove("ms-was-validated");
            self.$refs.disableModal.close();
            this.updateDialog = false;
        },
        enableGroup() {
            let self = this;

            return GroupAPI.enableGroup(
                self.groupId
            ).then(response => {
                if (!response.error) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    this.$router
                        .push(
                            this.CONTEXT_PATH + "/usersgroups/groups/" + self.groupId + "?enable"
                        )
                        .catch(err => {});
                }
            });
        },
        disableGroup(e) {

            let self = this;
            let form = $('#disableGroup')

            if(!checkFormAndTextareaValidations('disableReason',this.descRegex,form))
            {
                return;
            }
            self.$refs.disableModal.close();
            self.updateCall = false;

            return GroupAPI.disableGroup(
                self.groupId,
                self.disableReason
            ).then(response => {
                self.updateCall = true;
                if (!response.error) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.$router.push(self.CONTEXT_PATH + "/usersgroups/groups");
                }
            });
        },
        saveGroup() {
            let form = $('#formId')    
            let self = this;
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            self.dto.group.assignedUsers = self.$refs.userList.value;
            self.updateCall = false;
            GroupAPI.saveGroup(self.dto.group).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    if (self.newGroup) {
                        if (self.hierarchyId != null && self.hierarchyId != "") {
                            self.$router
                                .push(
                                    this.CONTEXT_PATH + "/usersgroups/hierarchies/" + self.hierarchyId
                                );
                            return
                        }
                        this.$router
                            .push(
                                this.CONTEXT_PATH + "/usersgroups/groups/" + response.data.id
                            )
                            .catch(err => {});
                    } else {
                        self.groupName = response.data.name;
                    }
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.dto.group.name = event.target.value;
        },
        redirectToList() {
            let self = this;
            if (!self.newGroup) {
                localStorage.setItem("GroupsList", "GroupsList");
            }
            this.$router.push(
                this.CONTEXT_PATH + '/usersgroups/groups'
            );
        },
        handleCancelBtn() {
            let self = this;
            if (self.hierarchyId != null && self.hierarchyId != "") {
                self.$router
                    .push(
                        this.CONTEXT_PATH + "/usersgroups/hierarchies/" + self.hierarchyId
                    );
                return
            }

            this.$router.push(
                this.CONTEXT_PATH + '/usersgroups/groups'
            );

        }
    }
}
</script>
